import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { SocialProvider } from '../types';

interface SocialRegistrationProps {
  providers: SocialProvider[];
  onProviderClick: (providerId: string) => void;
}

const SocialRegistration = ({ providers, onProviderClick }: SocialRegistrationProps) => {
  return (
    <div className="space-y-4">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border" />
        </div>
        <div className="relative flex justify-center text-xs uppercase">
          <span className="bg-background px-2 text-muted-foreground">Or continue with</span>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {providers.map((provider) => (
          <Button
            key={provider.id}
            variant="outline"
            onClick={() => onProviderClick(provider.id)}
            className="w-full"
          >
            <Icon name={provider.icon} size={20} color={provider.color} />
            <span className="ml-2">{provider.name}</span>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default SocialRegistration;